var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "el-dialog",
        {
          attrs: {
            title: _vm.dialogTitle,
            visible: _vm.dialogVisible,
            width: "70%",
            "close-on-click-modal": false,
            "before-close": _vm.handleClose,
          },
          on: {
            "update:visible": function ($event) {
              _vm.dialogVisible = $event
            },
            close: _vm.handleClose,
            opened: _vm.handleDialogOpened,
          },
        },
        [
          _c(
            "el-form",
            {
              ref: "storeForm",
              attrs: {
                model: _vm.formData,
                rules: _vm.formRules,
                "label-width": "120px",
                "label-position": "right",
              },
            },
            [
              _c("el-divider", { attrs: { "content-position": "left" } }, [
                _vm._v("基本信息"),
              ]),
              _vm._v(" "),
              _c(
                "el-row",
                { attrs: { gutter: 20 } },
                [
                  _c(
                    "el-col",
                    { attrs: { span: 12 } },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { label: "店铺名称：", prop: "storeName" } },
                        [
                          _c("el-input", {
                            attrs: {
                              placeholder: "请输入店铺名称",
                              disabled:
                                _vm.formData.editType == 2 ? true : false,
                            },
                            model: {
                              value: _vm.formData.storeName,
                              callback: function ($$v) {
                                _vm.$set(_vm.formData, "storeName", $$v)
                              },
                              expression: "formData.storeName",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-col",
                    { attrs: { span: 12 } },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { label: "门店状态：", prop: "storeStatus" } },
                        [
                          _c(
                            "el-select",
                            {
                              staticStyle: { width: "100%" },
                              attrs: { placeholder: "请选择门店状态" },
                              model: {
                                value: _vm.formData.storeStatus,
                                callback: function ($$v) {
                                  _vm.$set(_vm.formData, "storeStatus", $$v)
                                },
                                expression: "formData.storeStatus",
                              },
                            },
                            [
                              _c("el-option", {
                                attrs: { label: "已开业", value: "1" },
                              }),
                              _vm._v(" "),
                              _c("el-option", {
                                attrs: { label: "筹备中", value: "0" },
                              }),
                              _vm._v(" "),
                              _c("el-option", {
                                attrs: { label: "已停用", value: "-1" },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c("el-divider", { attrs: { "content-position": "left" } }, [
                _vm._v("图片上传"),
              ]),
              _vm._v(" "),
              _c(
                "el-row",
                { attrs: { gutter: 20 } },
                [
                  _c(
                    "el-col",
                    { attrs: { span: 12 } },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { label: "店铺LOGO：", prop: "logo" } },
                        [
                          _c("div", { staticClass: "logo-upload-container" }, [
                            _vm.formData.logo
                              ? _c("div", { staticClass: "logo-preview" }, [
                                  _c("img", {
                                    staticClass: "logo-image",
                                    attrs: { src: _vm.formData.logo },
                                    on: { click: _vm.previewLogo },
                                  }),
                                  _vm._v(" "),
                                  _c("div", { staticClass: "logo-overlay" }, [
                                    _c("i", {
                                      staticClass: "el-icon-view",
                                      attrs: { title: "预览" },
                                      on: { click: _vm.previewLogo },
                                    }),
                                    _vm._v(" "),
                                    _c("i", {
                                      staticClass: "el-icon-delete",
                                      attrs: { title: "删除" },
                                      on: { click: _vm.removeLogo },
                                    }),
                                  ]),
                                ])
                              : _c(
                                  "div",
                                  {
                                    staticClass: "logo-upload-placeholder",
                                    on: { click: _vm.handleLogoUpload },
                                  },
                                  [
                                    _c("i", { staticClass: "el-icon-plus" }),
                                    _vm._v(" "),
                                    _c("div", { staticClass: "upload-text" }, [
                                      _vm._v("上传LOGO"),
                                    ]),
                                  ]
                                ),
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "upload-tip" }, [
                            _vm._v(
                              "只能上传1张图片，支持jpg/png格式，建议尺寸为1:1"
                            ),
                          ]),
                        ]
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-col",
                    { attrs: { span: 12 } },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { label: "主图：", prop: "imageUrlList" } },
                        [
                          _c("div", { staticClass: "main-images-container" }, [
                            _c(
                              "div",
                              { staticClass: "image-list" },
                              [
                                _vm._l(
                                  _vm.formData.imageUrlList,
                                  function (image, index) {
                                    return _c(
                                      "div",
                                      { key: index, staticClass: "image-item" },
                                      [
                                        _c("img", {
                                          staticClass: "image-preview",
                                          attrs: { src: image },
                                          on: {
                                            click: function ($event) {
                                              return _vm.previewMainImage(
                                                image,
                                                index
                                              )
                                            },
                                          },
                                        }),
                                        _vm._v(" "),
                                        _c(
                                          "div",
                                          { staticClass: "image-overlay" },
                                          [
                                            _c("i", {
                                              staticClass: "el-icon-view",
                                              attrs: { title: "预览" },
                                              on: {
                                                click: function ($event) {
                                                  return _vm.previewMainImage(
                                                    image,
                                                    index
                                                  )
                                                },
                                              },
                                            }),
                                            _vm._v(" "),
                                            _c("i", {
                                              staticClass: "el-icon-delete",
                                              attrs: { title: "删除" },
                                              on: {
                                                click: function ($event) {
                                                  return _vm.removeMainImage(
                                                    index
                                                  )
                                                },
                                              },
                                            }),
                                          ]
                                        ),
                                      ]
                                    )
                                  }
                                ),
                                _vm._v(" "),
                                _vm.formData.imageUrlList.length < 10
                                  ? _c(
                                      "div",
                                      {
                                        staticClass: "upload-placeholder",
                                        on: {
                                          click: _vm.handleMainImageUpload,
                                        },
                                      },
                                      [
                                        _c("i", {
                                          staticClass: "el-icon-plus",
                                        }),
                                        _vm._v(" "),
                                        _c(
                                          "div",
                                          { staticClass: "upload-text" },
                                          [_vm._v("添加图片")]
                                        ),
                                      ]
                                    )
                                  : _vm._e(),
                              ],
                              2
                            ),
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "upload-tip" }, [
                            _vm._v(
                              "主图非必填，最多上传10张图片，支持jpg/png格式"
                            ),
                          ]),
                        ]
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c("el-divider", { attrs: { "content-position": "left" } }, [
                _vm._v("地址信息"),
              ]),
              _vm._v(" "),
              _c("store-address-picker", {
                ref: "addressPicker",
                attrs: {
                  region: _vm.formData.region,
                  "store-address": _vm.formData.storeAddress,
                  longitude: _vm.formData.longitude,
                  latitude: _vm.formData.latitude,
                  "area-options": _vm.areaOptions,
                  disabled: _vm.formData.editType == 2,
                  active: _vm.dialogVisible,
                },
                on: {
                  "update:region": function ($event) {
                    return _vm.$set(_vm.formData, "region", $event)
                  },
                  "update:storeAddress": function ($event) {
                    return _vm.$set(_vm.formData, "storeAddress", $event)
                  },
                  "update:store-address": function ($event) {
                    return _vm.$set(_vm.formData, "storeAddress", $event)
                  },
                  "update:longitude": function ($event) {
                    return _vm.$set(_vm.formData, "longitude", $event)
                  },
                  "update:latitude": function ($event) {
                    return _vm.$set(_vm.formData, "latitude", $event)
                  },
                },
              }),
              _vm._v(" "),
              _c("el-divider", { attrs: { "content-position": "left" } }, [
                _vm._v("业务类型"),
              ]),
              _vm._v(" "),
              _c(
                "el-row",
                { attrs: { gutter: 20 } },
                [
                  _c(
                    "el-col",
                    { attrs: { span: 12 } },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { label: "业务类型：", prop: "wmTgFlag" } },
                        [
                          _c(
                            "el-select",
                            {
                              staticStyle: { width: "100%" },
                              attrs: {
                                placeholder: "请选择业务类型",
                                multiple: "",
                                clearable: "",
                              },
                              on: { change: _vm.wmTgFlagChange },
                              model: {
                                value: _vm.formData.wmTgFlag,
                                callback: function ($$v) {
                                  _vm.$set(_vm.formData, "wmTgFlag", $$v)
                                },
                                expression: "formData.wmTgFlag",
                              },
                            },
                            [
                              _c("el-option", {
                                attrs: { label: "实物", value: "1" },
                              }),
                              _vm._v(" "),
                              _c("el-option", {
                                attrs: { label: "团购", value: "2" },
                              }),
                              _vm._v(" "),
                              _c("el-option", {
                                attrs: { label: "酒店", value: "3" },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _vm.formData.wmTgFlag.length > 0
                    ? _c(
                        "el-col",
                        { attrs: { span: 12 } },
                        [
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                label: "店铺类型：",
                                prop: "storeTypes",
                              },
                            },
                            [
                              _c(
                                "el-select",
                                {
                                  staticStyle: { width: "100%" },
                                  attrs: {
                                    placeholder: "请选择店铺类型",
                                    filterable: "",
                                    multiple: "",
                                    loading: _vm.storeTypeLoading,
                                    clearable: "",
                                  },
                                  on: { focus: _vm.handleStoreTypeFocus },
                                  model: {
                                    value: _vm.formData.storeTypes,
                                    callback: function ($$v) {
                                      _vm.$set(_vm.formData, "storeTypes", $$v)
                                    },
                                    expression: "formData.storeTypes",
                                  },
                                },
                                _vm._l(
                                  _vm.storeTypeOptionsToChose,
                                  function (type) {
                                    return _c("el-option", {
                                      key: type.key,
                                      attrs: {
                                        label: type.value,
                                        value: type.key,
                                      },
                                    })
                                  }
                                ),
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.hasProduct
                    ? _c(
                        "el-col",
                        { attrs: { span: 12 } },
                        [
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                label: "配送方式：",
                                prop: "deliveryTypes",
                              },
                            },
                            [
                              _c(
                                "el-select",
                                {
                                  staticStyle: { width: "100%" },
                                  attrs: {
                                    clearable: "",
                                    multiple: "",
                                    placeholder: "请选择配送方式",
                                  },
                                  model: {
                                    value: _vm.formData.deliveryTypes,
                                    callback: function ($$v) {
                                      _vm.$set(
                                        _vm.formData,
                                        "deliveryTypes",
                                        $$v
                                      )
                                    },
                                    expression: "formData.deliveryTypes",
                                  },
                                },
                                [
                                  _c("el-option", {
                                    attrs: { label: "外卖", value: "takeout" },
                                  }),
                                  _vm._v(" "),
                                  _c("el-option", {
                                    attrs: {
                                      label: "自提",
                                      value: "self_pickup",
                                    },
                                  }),
                                  _vm._v(" "),
                                  _c("el-option", {
                                    attrs: { label: "快递", value: "express" },
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      )
                    : _vm._e(),
                ],
                1
              ),
              _vm._v(" "),
              _vm.hasTakeout
                ? _c("el-divider", { attrs: { "content-position": "left" } }, [
                    _vm._v("外卖运营信息"),
                  ])
                : _vm._e(),
              _vm._v(" "),
              _vm.hasTakeout
                ? _c(
                    "div",
                    [
                      _c("el-row", { attrs: { gutter: 20 } }),
                      _vm._v(" "),
                      _c(
                        "el-row",
                        { attrs: { gutter: 20 } },
                        [
                          _c(
                            "el-col",
                            { attrs: { span: 12 } },
                            [
                              _c(
                                "el-form-item",
                                {
                                  attrs: {
                                    label: "起送费：",
                                    prop: "deliveryStartFee",
                                  },
                                },
                                [
                                  _c(
                                    "el-input",
                                    {
                                      attrs: {
                                        placeholder: "请输入起送费",
                                        type: "number",
                                      },
                                      model: {
                                        value: _vm.formData.deliveryStartFee,
                                        callback: function ($$v) {
                                          _vm.$set(
                                            _vm.formData,
                                            "deliveryStartFee",
                                            _vm._n($$v)
                                          )
                                        },
                                        expression: "formData.deliveryStartFee",
                                      },
                                    },
                                    [
                                      _c("template", { slot: "append" }, [
                                        _vm._v("元"),
                                      ]),
                                    ],
                                    2
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "el-col",
                            { attrs: { span: 12 } },
                            [
                              _c(
                                "el-form-item",
                                {
                                  attrs: {
                                    label: "打包费：",
                                    prop: "packingFee",
                                  },
                                },
                                [
                                  _c(
                                    "el-input",
                                    {
                                      attrs: {
                                        placeholder: "请输入打包费",
                                        type: "number",
                                      },
                                      model: {
                                        value: _vm.formData.packingFee,
                                        callback: function ($$v) {
                                          _vm.$set(
                                            _vm.formData,
                                            "packingFee",
                                            _vm._n($$v)
                                          )
                                        },
                                        expression: "formData.packingFee",
                                      },
                                    },
                                    [
                                      _c("template", { slot: "append" }, [
                                        _vm._v("元"),
                                      ]),
                                    ],
                                    2
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "el-row",
                        { attrs: { gutter: 20 } },
                        [
                          _c(
                            "el-col",
                            { attrs: { span: 12 } },
                            [
                              _c(
                                "el-form-item",
                                {
                                  attrs: {
                                    label: "配送模板：",
                                    prop: "deliveryTemplateId",
                                  },
                                },
                                [
                                  _c(
                                    "el-select",
                                    {
                                      staticStyle: { width: "100%" },
                                      attrs: {
                                        placeholder: "请选择配送模板",
                                        remote: "",
                                        "remote-method":
                                          _vm.searchShippingTemplates,
                                        loading: _vm.shippingTemplateLoading,
                                        clearable: "",
                                      },
                                      on: {
                                        change:
                                          _vm.handleDeliveryTemplateChange,
                                      },
                                      model: {
                                        value: _vm.formData.deliveryTemplateId,
                                        callback: function ($$v) {
                                          _vm.$set(
                                            _vm.formData,
                                            "deliveryTemplateId",
                                            $$v
                                          )
                                        },
                                        expression:
                                          "formData.deliveryTemplateId",
                                      },
                                    },
                                    _vm._l(
                                      _vm.shippingTemplateOptions,
                                      function (template) {
                                        return _c("el-option", {
                                          key: template.key,
                                          attrs: {
                                            label: template.value,
                                            value: template.key,
                                          },
                                        })
                                      }
                                    ),
                                    1
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _vm.isSfTemplateSelected
                        ? _c(
                            "el-row",
                            { key: "sf-fields", attrs: { gutter: 20 } },
                            [
                              _c(
                                "el-col",
                                { attrs: { span: 12 } },
                                [
                                  _c(
                                    "el-form-item",
                                    {
                                      attrs: {
                                        label: "顺丰门店ID：",
                                        prop: "sfLogisticsId",
                                        required: "",
                                      },
                                    },
                                    [
                                      _c("el-input", {
                                        attrs: {
                                          placeholder: "请输入顺丰门店ID",
                                          clearable: "",
                                        },
                                        on: {
                                          blur: function ($event) {
                                            _vm.$refs.storeForm &&
                                              _vm.$refs.storeForm.validateField(
                                                "sfLogisticsId"
                                              )
                                          },
                                        },
                                        model: {
                                          value: _vm.formData.sfLogisticsId,
                                          callback: function ($$v) {
                                            _vm.$set(
                                              _vm.formData,
                                              "sfLogisticsId",
                                              $$v
                                            )
                                          },
                                          expression: "formData.sfLogisticsId",
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "el-col",
                                { attrs: { span: 12 } },
                                [
                                  _c(
                                    "el-form-item",
                                    {
                                      attrs: {
                                        label: "是否顺丰门店：",
                                        prop: "sfFlag",
                                      },
                                    },
                                    [
                                      _c(
                                        "el-radio-group",
                                        {
                                          model: {
                                            value: _vm.formData.sfFlag,
                                            callback: function ($$v) {
                                              _vm.$set(
                                                _vm.formData,
                                                "sfFlag",
                                                _vm._n($$v)
                                              )
                                            },
                                            expression: "formData.sfFlag",
                                          },
                                        },
                                        [
                                          _c(
                                            "el-radio",
                                            { attrs: { label: 1 } },
                                            [_vm._v("是")]
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "el-radio",
                                            {
                                              staticStyle: {
                                                "margin-left": "16px",
                                              },
                                              attrs: { label: 0 },
                                            },
                                            [_vm._v("否")]
                                          ),
                                        ],
                                        1
                                      ),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.showAutoDelivery
                        ? _c(
                            "el-row",
                            {
                              key: "auto-delivery-fields",
                              attrs: { gutter: 20 },
                            },
                            [
                              _c(
                                "el-col",
                                { attrs: { span: 12 } },
                                [
                                  _c(
                                    "el-form-item",
                                    {
                                      attrs: {
                                        label: "是否自动发货：",
                                        prop: "autoDelivery",
                                      },
                                    },
                                    [
                                      _c(
                                        "el-radio-group",
                                        {
                                          model: {
                                            value: _vm.formData.autoDelivery,
                                            callback: function ($$v) {
                                              _vm.$set(
                                                _vm.formData,
                                                "autoDelivery",
                                                $$v
                                              )
                                            },
                                            expression: "formData.autoDelivery",
                                          },
                                        },
                                        [
                                          _c(
                                            "el-radio",
                                            { attrs: { label: 1 } },
                                            [_vm._v("是")]
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "el-radio",
                                            { attrs: { label: 2 } },
                                            [_vm._v("否")]
                                          ),
                                        ],
                                        1
                                      ),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          )
                        : _vm._e(),
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.hasGroupBuy
                ? _c("el-divider", { attrs: { "content-position": "left" } }, [
                    _vm._v("团购运营信息"),
                  ])
                : _vm._e(),
              _vm._v(" "),
              _vm.hasGroupBuy
                ? _c(
                    "div",
                    [
                      _c(
                        "el-row",
                        { attrs: { gutter: 20 } },
                        [
                          _c("el-col", { attrs: { span: 24 } }, [
                            _c(
                              "div",
                              {
                                staticStyle: {
                                  padding: "20px",
                                  "text-align": "center",
                                  color: "#909399",
                                },
                              },
                              [
                                _vm._v(
                                  "\n                团购运营信息无需配置\n              "
                                ),
                              ]
                            ),
                          ]),
                        ],
                        1
                      ),
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.hasExpress
                ? _c("el-divider", { attrs: { "content-position": "left" } }, [
                    _vm._v("快递运营信息"),
                  ])
                : _vm._e(),
              _vm._v(" "),
              _vm.hasExpress
                ? _c(
                    "el-form-item",
                    { attrs: { label: "运费模板：", prop: "frtTemplateId" } },
                    [
                      _c(
                        "el-select",
                        {
                          staticClass: "form-width",
                          attrs: {
                            placeholder: "请选择运费模板",
                            clearable: "",
                            filterable: "",
                          },
                          model: {
                            value: _vm.formData.frtTemplateId,
                            callback: function ($$v) {
                              _vm.$set(_vm.formData, "frtTemplateId", $$v)
                            },
                            expression: "formData.frtTemplateId",
                          },
                        },
                        _vm._l(_vm.frtTemplateOptions, function (item) {
                          return _c("el-option", {
                            key: item.value,
                            attrs: { label: item.label, value: item.value },
                          })
                        }),
                        1
                      ),
                      _vm._v(" "),
                      _c("div", { staticClass: "discount-tip" }, [
                        _vm._v("若商品运费模板没有配置则默认使用此处模板"),
                      ]),
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _c("el-divider", { attrs: { "content-position": "left" } }, [
                _vm._v("营业信息"),
              ]),
              _vm._v(" "),
              _c(
                "el-row",
                { attrs: { gutter: 20 } },
                [
                  _c(
                    "el-col",
                    { attrs: { span: 12 } },
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: "营业状态：",
                            prop: "businessStatus",
                          },
                        },
                        [
                          _c(
                            "el-select",
                            {
                              staticStyle: { width: "100%" },
                              attrs: {
                                placeholder: "请选择营业状态",
                                disabled:
                                  _vm.formData.editType == 2 ? true : false,
                              },
                              model: {
                                value: _vm.formData.businessStatus,
                                callback: function ($$v) {
                                  _vm.$set(_vm.formData, "businessStatus", $$v)
                                },
                                expression: "formData.businessStatus",
                              },
                            },
                            [
                              _c("el-option", {
                                attrs: { label: "营业中", value: "1" },
                              }),
                              _vm._v(" "),
                              _c("el-option", {
                                attrs: { label: "休息中", value: "0" },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _vm.hasPickup || _vm.hasTakeout
                    ? _c(
                        "el-col",
                        { attrs: { span: 12 } },
                        [
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                label: "最大出餐时间：",
                                prop: "maxMealTime",
                              },
                            },
                            [
                              _c(
                                "el-input",
                                {
                                  attrs: {
                                    placeholder: "请输入最大出餐时间",
                                    type: "number",
                                    min: 1,
                                  },
                                  nativeOn: {
                                    wheel: function ($event) {
                                      $event.preventDefault()
                                    },
                                  },
                                  model: {
                                    value: _vm.formData.maxMealTime,
                                    callback: function ($$v) {
                                      _vm.$set(
                                        _vm.formData,
                                        "maxMealTime",
                                        _vm._n($$v)
                                      )
                                    },
                                    expression: "formData.maxMealTime",
                                  },
                                },
                                [
                                  _c("template", { slot: "append" }, [
                                    _vm._v("分钟"),
                                  ]),
                                ],
                                2
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      )
                    : _vm._e(),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-row",
                { attrs: { gutter: 20 } },
                [
                  _c(
                    "el-col",
                    { attrs: { span: 24 } },
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: "营业时间：",
                            prop: "businessTimeList",
                          },
                        },
                        [
                          _c("business-hours-picker", {
                            ref: "businessHoursPicker",
                            on: { change: _vm.handleBusinessTimeChange },
                            model: {
                              value: _vm.formData.businessTimeList,
                              callback: function ($$v) {
                                _vm.$set(_vm.formData, "businessTimeList", $$v)
                              },
                              expression: "formData.businessTimeList",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _vm.hasHotel
                ? [
                    _c(
                      "el-divider",
                      { attrs: { "content-position": "left" } },
                      [_vm._v("酒店运营信息")]
                    ),
                    _vm._v(" "),
                    _c("div", { staticClass: "hotel-refund-section" }, [
                      _c(
                        "div",
                        { staticClass: "hotel-refund-header" },
                        [
                          _c("span", { staticClass: "section-title" }, [
                            _c("span", { staticClass: "required-mark" }, [
                              _vm._v("*"),
                            ]),
                            _vm._v("取消订单店铺退款配置"),
                          ]),
                          _vm._v(" "),
                          _c(
                            "el-button",
                            {
                              attrs: {
                                type: "text",
                                size: "small",
                                icon: "el-icon-refresh",
                              },
                              on: { click: _vm.handleResetHotelRefundConfigs },
                            },
                            [_vm._v("恢复默认")]
                          ),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "hotel-refund-table" },
                        [
                          _c(
                            "div",
                            { staticClass: "hotel-refund-row header-row" },
                            [
                              _c("span", { staticClass: "col-label" }, [
                                _vm._v("距离入住时间"),
                              ]),
                              _vm._v(" "),
                              _c("span", { staticClass: "col-action" }),
                            ]
                          ),
                          _vm._v(" "),
                          _c("div", { staticClass: "hotel-refund-row" }, [
                            _c(
                              "span",
                              { staticClass: "row-text" },
                              [
                                _vm._v(
                                  "\n                  超过 \n                  "
                                ),
                                _c("el-input-number", {
                                  attrs: {
                                    min: 1,
                                    precision: 0,
                                    step: 1,
                                    size: "small",
                                    "controls-position": "right",
                                    disabled:
                                      _vm.formData.hotelRefundConfigs.length >
                                      1,
                                  },
                                  on: {
                                    change: function (val) {
                                      return _vm.handleRefundStartHourChange(
                                        0,
                                        val
                                      )
                                    },
                                  },
                                  model: {
                                    value:
                                      _vm.formData.hotelRefundConfigs[0]
                                        .startHour,
                                    callback: function ($$v) {
                                      _vm.$set(
                                        _vm.formData.hotelRefundConfigs[0],
                                        "startHour",
                                        $$v
                                      )
                                    },
                                    expression:
                                      "formData.hotelRefundConfigs[0].startHour",
                                  },
                                }),
                                _vm._v(" 小时，退款比例\n                "),
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "span",
                              { staticClass: "refund-input" },
                              [
                                _c("el-input-number", {
                                  attrs: {
                                    min: 1,
                                    max: 100,
                                    disabled: true,
                                    size: "small",
                                    "controls-position": "right",
                                  },
                                  model: {
                                    value:
                                      _vm.formData.hotelRefundConfigs[0]
                                        .refundRate,
                                    callback: function ($$v) {
                                      _vm.$set(
                                        _vm.formData.hotelRefundConfigs[0],
                                        "refundRate",
                                        $$v
                                      )
                                    },
                                    expression:
                                      "formData.hotelRefundConfigs[0].refundRate",
                                  },
                                }),
                                _vm._v(" %\n                "),
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c("span", { staticClass: "col-action" }, [
                              _vm.formData.hotelRefundConfigs.length === 1
                                ? _c("i", {
                                    staticClass:
                                      "el-icon-circle-plus-outline action-icon",
                                    on: { click: _vm.handleAddRefundRow },
                                  })
                                : _vm._e(),
                            ]),
                          ]),
                          _vm._v(" "),
                          _vm._l(
                            _vm.formData.hotelRefundConfigs.slice(1),
                            function (item, index) {
                              return _c(
                                "div",
                                { key: index, staticClass: "hotel-refund-row" },
                                [
                                  _c(
                                    "span",
                                    { staticClass: "row-text" },
                                    [
                                      _c("el-input-number", {
                                        attrs: {
                                          min: 1,
                                          max: Number(item.endHour) - 1,
                                          precision: 0,
                                          step: 1,
                                          size: "small",
                                          "controls-position": "right",
                                          disabled:
                                            index !==
                                            _vm.formData.hotelRefundConfigs
                                              .length -
                                              2,
                                        },
                                        on: {
                                          change: function (val) {
                                            return _vm.handleRefundStartHourChange(
                                              index + 1,
                                              val
                                            )
                                          },
                                        },
                                        model: {
                                          value: item.startHour,
                                          callback: function ($$v) {
                                            _vm.$set(item, "startHour", $$v)
                                          },
                                          expression: "item.startHour",
                                        },
                                      }),
                                      _vm._v(" ~\n                  "),
                                      _c("el-input-number", {
                                        attrs: {
                                          precision: 0,
                                          step: 1,
                                          size: "small",
                                          "controls-position": "right",
                                          disabled: true,
                                        },
                                        model: {
                                          value: item.endHour,
                                          callback: function ($$v) {
                                            _vm.$set(item, "endHour", $$v)
                                          },
                                          expression: "item.endHour",
                                        },
                                      }),
                                      _vm._v(
                                        " 小时，退款比例\n                "
                                      ),
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "span",
                                    { staticClass: "refund-input" },
                                    [
                                      _c("el-input-number", {
                                        attrs: {
                                          min: 1,
                                          max: 100,
                                          precision: 0,
                                          step: 1,
                                          size: "small",
                                          "controls-position": "right",
                                        },
                                        model: {
                                          value: item.refundRate,
                                          callback: function ($$v) {
                                            _vm.$set(item, "refundRate", $$v)
                                          },
                                          expression: "item.refundRate",
                                        },
                                      }),
                                      _vm._v(" %\n                "),
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c("span", { staticClass: "col-action" }, [
                                    index ===
                                    _vm.formData.hotelRefundConfigs.length - 2
                                      ? _c("i", {
                                          staticClass:
                                            "el-icon-remove-outline action-icon",
                                          on: {
                                            click: function ($event) {
                                              return _vm.handleRemoveRefundRow(
                                                index
                                              )
                                            },
                                          },
                                        })
                                      : _vm._e(),
                                    _vm._v(" "),
                                    index ===
                                    _vm.formData.hotelRefundConfigs.length - 2
                                      ? _c("i", {
                                          staticClass:
                                            "el-icon-circle-plus-outline action-icon",
                                          on: { click: _vm.handleAddRefundRow },
                                        })
                                      : _vm._e(),
                                  ]),
                                ]
                              )
                            }
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            { staticClass: "hotel-refund-row limit-row" },
                            [
                              _c("span", { staticClass: "row-text" }, [
                                _vm._v(
                                  "\n                  距离入住时间 \n                  "
                                ),
                                _c("span", { staticClass: "time-value" }, [
                                  _vm._v(
                                    _vm._s(_vm.hotelRefundCancelLimitHour)
                                  ),
                                ]),
                                _vm._v(
                                  " 小时以内，订单无法取消\n                "
                                ),
                              ]),
                              _vm._v(" "),
                              _c("span", { staticClass: "col-action" }),
                            ]
                          ),
                        ],
                        2
                      ),
                    ]),
                  ]
                : _vm._e(),
              _vm._v(" "),
              _c("el-divider", { attrs: { "content-position": "left" } }, [
                _vm._v("联系方式"),
              ]),
              _vm._v(" "),
              _c(
                "el-row",
                { attrs: { gutter: 20 } },
                [
                  _c(
                    "el-col",
                    { attrs: { span: 12 } },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { label: "门店联系电话：", prop: "phone" } },
                        [
                          _c("el-input", {
                            attrs: {
                              placeholder:
                                "支持多个号码，用逗号、分号或空格分隔。格式：手机号、座机号(区号-号码-分机号)、400/800电话",
                              disabled:
                                _vm.formData.editType == 2 ? true : false,
                              type: "textarea",
                              rows: 2,
                            },
                            model: {
                              value: _vm.formData.phone,
                              callback: function ($$v) {
                                _vm.$set(_vm.formData, "phone", $$v)
                              },
                              expression: "formData.phone",
                            },
                          }),
                          _vm._v(" "),
                          _c("div", { staticClass: "field-tip" }, [
                            _vm._v(
                              "示例：138****0987, 010-12345678, 400-123-4567"
                            ),
                          ]),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c("el-divider", { attrs: { "content-position": "left" } }, [
                _vm._v("订单变更通知"),
              ]),
              _vm._v(" "),
              _c(
                "el-row",
                { attrs: { gutter: 20 } },
                [
                  _c(
                    "el-col",
                    { attrs: { span: 12 } },
                    [
                      _c(
                        "el-form-item",
                        {
                          staticClass: "notify-switch-item",
                          attrs: {
                            label: "消息通知开关：",
                            prop: "messageNotifyFlag",
                          },
                        },
                        [
                          _c(
                            "div",
                            { staticClass: "notify-toggle-wrapper" },
                            [
                              _c("el-switch", {
                                attrs: {
                                  "active-value": 1,
                                  "inactive-value": 0,
                                },
                                on: { change: _vm.handleMessageNotifyChange },
                                model: {
                                  value: _vm.formData.messageNotifyFlag,
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.formData,
                                      "messageNotifyFlag",
                                      $$v
                                    )
                                  },
                                  expression: "formData.messageNotifyFlag",
                                },
                              }),
                              _vm._v(" "),
                              _c(
                                "el-tooltip",
                                {
                                  attrs: {
                                    content:
                                      "关闭后将无法收到下单、退款及库存预警消息，请谨慎操作",
                                    placement: "top",
                                  },
                                },
                                [
                                  _c("i", {
                                    staticClass:
                                      "el-icon-question tooltip-icon",
                                  }),
                                ]
                              ),
                            ],
                            1
                          ),
                        ]
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _vm.formData.messageNotifyFlag === 1
                ? _c(
                    "el-row",
                    { attrs: { gutter: 20 } },
                    [
                      _c(
                        "el-col",
                        { attrs: { span: 8 } },
                        [
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                label: "微信号：",
                                prop: "wechatId",
                                required: true,
                              },
                            },
                            [
                              _c("el-input", {
                                attrs: {
                                  placeholder: "请输入",
                                  maxlength: "30",
                                },
                                model: {
                                  value: _vm.formData.wechatId,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.formData, "wechatId", $$v)
                                  },
                                  expression: "formData.wechatId",
                                },
                              }),
                              _vm._v(" "),
                              _c("div", { staticClass: "field-tip" }, [
                                _vm._v(
                                  "需要打开允许微信号添加，否则会添加失败"
                                ),
                              ]),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "el-col",
                        { attrs: { span: 8 } },
                        [
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                label: "手机号：",
                                prop: "smsPhone",
                                required: true,
                              },
                            },
                            [
                              _c("el-input", {
                                attrs: {
                                  placeholder: "请输入",
                                  maxlength: "11",
                                },
                                model: {
                                  value: _vm.formData.smsPhone,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.formData, "smsPhone", $$v)
                                  },
                                  expression: "formData.smsPhone",
                                },
                              }),
                              _vm._v(" "),
                              _c("div", { staticClass: "field-tip" }, [
                                _vm._v("示例：138****0987"),
                              ]),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "el-col",
                        { attrs: { span: 8 } },
                        [
                          _c(
                            "el-form-item",
                            { attrs: { label: "邮箱：", prop: "email" } },
                            [
                              _c("el-input", {
                                attrs: { placeholder: "请输入邮箱" },
                                model: {
                                  value: _vm.formData.email,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.formData, "email", $$v)
                                  },
                                  expression: "formData.email",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.hasTakeout || _vm.hasHotel
                ? _c("el-divider", { attrs: { "content-position": "left" } }, [
                    _vm._v("其他信息"),
                  ])
                : _vm._e(),
              _vm._v(" "),
              _vm.hasTakeout
                ? _c(
                    "el-row",
                    { attrs: { gutter: 20 } },
                    [
                      _c(
                        "el-col",
                        { attrs: { span: 12 } },
                        [
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                label: "是否使用外卖打印设备：",
                                prop: "usePrinterDevice",
                              },
                            },
                            [
                              _c(
                                "el-select",
                                {
                                  staticStyle: { width: "100%" },
                                  attrs: {
                                    placeholder: "请选择是否使用打印设备",
                                  },
                                  on: {
                                    change: _vm.handleUsePrinterDeviceChange,
                                  },
                                  model: {
                                    value: _vm.formData.usePrinterDevice,
                                    callback: function ($$v) {
                                      _vm.$set(
                                        _vm.formData,
                                        "usePrinterDevice",
                                        $$v
                                      )
                                    },
                                    expression: "formData.usePrinterDevice",
                                  },
                                },
                                [
                                  _c("el-option", {
                                    attrs: { label: "是", value: true },
                                  }),
                                  _vm._v(" "),
                                  _c("el-option", {
                                    attrs: { label: "否", value: false },
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "el-col",
                        { attrs: { span: 12 } },
                        [
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                label: "打印机序列号：",
                                prop: "printerSn",
                              },
                            },
                            [
                              _c("el-input", {
                                attrs: {
                                  placeholder: "请输入打印机序列号",
                                  disabled:
                                    !_vm.formData.usePrinterDevice ||
                                    (Number(_vm.formData.editType) === 2 &&
                                      Boolean(
                                        _vm.originalPrinterSn &&
                                          _vm.originalPrinterSn.trim()
                                      )),
                                },
                                model: {
                                  value: _vm.formData.printerSn,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.formData, "printerSn", $$v)
                                  },
                                  expression: "formData.printerSn",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.hasHotel
                ? _c(
                    "el-row",
                    { attrs: { gutter: 20 } },
                    [
                      _c(
                        "el-col",
                        { attrs: { span: 12 } },
                        [
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                label: "是否使用酒店打印设备：",
                                prop: "usePrinterDevice2",
                              },
                            },
                            [
                              _c(
                                "el-select",
                                {
                                  staticStyle: { width: "100%" },
                                  attrs: {
                                    placeholder: "请选择是否使用打印设备",
                                  },
                                  on: {
                                    change: _vm.handleUsePrinterDeviceChange,
                                  },
                                  model: {
                                    value: _vm.formData.usePrinterDevice2,
                                    callback: function ($$v) {
                                      _vm.$set(
                                        _vm.formData,
                                        "usePrinterDevice2",
                                        $$v
                                      )
                                    },
                                    expression: "formData.usePrinterDevice2",
                                  },
                                },
                                [
                                  _c("el-option", {
                                    attrs: { label: "是", value: true },
                                  }),
                                  _vm._v(" "),
                                  _c("el-option", {
                                    attrs: { label: "否", value: false },
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "el-col",
                        { attrs: { span: 12 } },
                        [
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                label: "打印机序列号：",
                                prop: "printerSn2",
                              },
                            },
                            [
                              _c("el-input", {
                                attrs: {
                                  placeholder: "请输入打印机序列号",
                                  disabled:
                                    !_vm.formData.usePrinterDevice2 ||
                                    (Number(_vm.formData.editType) === 2 &&
                                      Boolean(
                                        _vm.originalPrinterSn2 &&
                                          _vm.originalPrinterSn2.trim()
                                      )),
                                },
                                model: {
                                  value: _vm.formData.printerSn2,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.formData, "printerSn2", $$v)
                                  },
                                  expression: "formData.printerSn2",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _c(
                "el-row",
                { attrs: { gutter: 20 } },
                [
                  _vm.showReceiptTemplateField
                    ? _c(
                        "el-col",
                        { attrs: { span: 12 } },
                        [
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                label: "小票模板：",
                                prop: "ticketTemplateIds",
                              },
                            },
                            [
                              _c(
                                "el-select",
                                {
                                  staticStyle: { width: "100%" },
                                  attrs: {
                                    placeholder: "请选择小票模板",
                                    multiple: "",
                                    clearable: "",
                                    filterable: "",
                                    remote: "",
                                    "remote-method": _vm.searchReceiptTemplates,
                                    loading: _vm.receiptTemplateLoading,
                                  },
                                  model: {
                                    value: _vm.formData.ticketTemplateIds,
                                    callback: function ($$v) {
                                      _vm.$set(
                                        _vm.formData,
                                        "ticketTemplateIds",
                                        $$v
                                      )
                                    },
                                    expression: "formData.ticketTemplateIds",
                                  },
                                },
                                _vm._l(
                                  _vm.receiptTemplateOptions,
                                  function (item) {
                                    return _c("el-option", {
                                      key: item.id,
                                      attrs: {
                                        label: item.templateName,
                                        value: String(item.id),
                                      },
                                    })
                                  }
                                ),
                                1
                              ),
                              _vm._v(" "),
                              _c("div", { staticClass: "field-tip" }, [
                                _vm._v(
                                  "按配置顺序依次打印；外卖自提订单默认打印全部小票；小票号规则：下单月日+当天下单顺序"
                                ),
                              ]),
                            ],
                            1
                          ),
                        ],
                        1
                      )
                    : _vm._e(),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-row",
                { attrs: { gutter: 20 } },
                [
                  _c(
                    "el-col",
                    { attrs: { span: 24 } },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { label: "店铺简介：" } },
                        [
                          _c("Tinymce", {
                            ref: "tinymceEditor",
                            staticClass: "store-description-editor",
                            attrs: {
                              height: 300,
                              sourceType: "store",
                              disabled:
                                _vm.formData.editType == 2 ? true : false,
                            },
                            on: { change: _vm.handleTinymceChange },
                            model: {
                              value: _vm.formData.storeDesc,
                              callback: function ($$v) {
                                _vm.$set(_vm.formData, "storeDesc", $$v)
                              },
                              expression: "formData.storeDesc",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-row",
                { attrs: { gutter: 20 } },
                [
                  _c(
                    "el-col",
                    { attrs: { span: 24 } },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { label: "备注：" } },
                        [
                          _c("el-input", {
                            attrs: {
                              type: "textarea",
                              rows: 3,
                              placeholder: "请输入备注信息",
                            },
                            model: {
                              value: _vm.formData.remark,
                              callback: function ($$v) {
                                _vm.$set(_vm.formData, "remark", $$v)
                              },
                              expression: "formData.remark",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            2
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c("el-button", { on: { click: _vm.handleClose } }, [
                _vm._v("取消"),
              ]),
              _vm._v(" "),
              _c(
                "el-button",
                { attrs: { type: "primary" }, on: { click: _vm.handleSubmit } },
                [_vm._v("提交")]
              ),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-dialog",
        {
          attrs: {
            visible: _vm.imagePreviewVisible,
            title: "图片预览",
            width: "80%",
            center: "",
            "close-on-click-modal": true,
            "close-on-press-escape": true,
          },
          on: {
            "update:visible": function ($event) {
              _vm.imagePreviewVisible = $event
            },
          },
        },
        [
          _c("div", { staticClass: "image-preview-container" }, [
            _c("img", {
              staticClass: "preview-image",
              attrs: { src: _vm.currentPreviewImage, alt: "预览图片" },
            }),
            _vm._v(" "),
            _vm.isMainImagePreview && _vm.formData.imageUrlList.length > 1
              ? _c(
                  "div",
                  { staticClass: "image-navigation" },
                  [
                    _c("el-button", {
                      staticClass: "nav-button prev-button",
                      attrs: {
                        disabled: _vm.currentImageIndex <= 0,
                        circle: "",
                        icon: "el-icon-arrow-left",
                      },
                      on: { click: _vm.prevImage },
                    }),
                    _vm._v(" "),
                    _c("span", { staticClass: "image-counter" }, [
                      _vm._v(
                        _vm._s(_vm.currentImageIndex + 1) +
                          " / " +
                          _vm._s(_vm.formData.imageUrlList.length)
                      ),
                    ]),
                    _vm._v(" "),
                    _c("el-button", {
                      staticClass: "nav-button next-button",
                      attrs: {
                        disabled:
                          _vm.currentImageIndex >=
                          _vm.formData.imageUrlList.length - 1,
                        circle: "",
                        icon: "el-icon-arrow-right",
                      },
                      on: { click: _vm.nextImage },
                    }),
                  ],
                  1
                )
              : _vm._e(),
          ]),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }